module.exports = __webpack_public_path__ + "officialStatic/img/coll-bg.347bf03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/coll-bg.png
// module id = VInO
// module chunks = 0